import { render, staticRenderFns } from "./DisplayControl.vue?vue&type=template&id=bd288ed4&scoped=true&"
import script from "./DisplayControl.vue?vue&type=script&lang=js&"
export * from "./DisplayControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd288ed4",
  null
  
)

export default component.exports